import { isKey } from '../helpers.js'
import { sendRequest } from '../../../lib-alme-request/src/lib-alme-request';

export default function IvaCommands(context) {
    let { evaluate, dispatch, settings, origin } = context;

    function _AppEvent(name, ...args) {
        name = evaluate(name);
        if (isKey(name)) {
            let [o, c] = [origin, settings.originConstants];
            sendRequest({
                eventName  : String(name),
                parameters : evaluate(['Object', ...args]),
                messageType: settings.messageConstants.appeventRequest,
                origin     : (o === c.internal || o === c.external || o === c.deferredAppCall) ? o : c.internal
            });
        }
    }

    function _Unit(unitId, displayText = '', ...args) {
        unitId      = evaluate(unitId);
        displayText = evaluate(displayText);
        if (isKey(unitId)) {
            sendRequest({
                unitId     : String(unitId),
                displayText: String(displayText || ''),
                parameters : evaluate(['Object', ...args]),
                messageType: settings.messageConstants.requestUnitRequest,
                origin     : settings.originConstants.click // currently the only choice
            });
        }
    }

    function _Converse(text, displayText = '', ...args) {
        text        = evaluate(text);
        displayText = evaluate(displayText);
        if (isKey(text)) {
            let [o, c] = [origin, settings.originConstants];
            sendRequest({
                text       : String(text),
                displayText: String(displayText || text),
                parameters : evaluate(['Object', ...args]),
                messageType: settings.messageConstants.converseRequest,
                origin     : (o === c.typed || o === c.click || o === c.external || o === c.voice) ? o : c.typed
            });
        }
    }

    function Minimize(isMinimized = true) {
        dispatch({
            type : 'SET_MINIMIZE_WINDOW',
            payload : {
                value: isMinimized,
                stateLocation: settings.stateLocations.Window.IsMinimized
            }
        });
    }

    function NewSession() {
        dispatch({
            type: 'SET_SESSION_ID',
            payload: {
                sessionId                 : evaluate(['NewGuid']),
                sessionIdStateLocation    : settings.stateLocations.Conversation.sessionId,
                activeSessionStateLocation: settings.stateLocations.Conversation.isActiveSession
            }
        });
    }

    let EndSession = NewSession;

    return { _AppEvent, _Unit, _Converse, Minimize, NewSession, EndSession };
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/command-action-handler/src/commands/iva.js